<template>
    <MainContent>
        <template v-slot:header>
            <PageTitle title="Detalles del usuario"/>
        </template>

        <template v-slot:content>
            <DatosUsuario :lista_id="lista_id" :user_id="user_id"/>
        </template>
    </MainContent>
</template>

<script>
    import MainContent from '@/components/backend/components/MainContent';
    import PageTitle from '@/components/backend/components/PageTitleComponent';
    import DatosUsuario from '@/components/common/usuario/DatosUsuario';

    export default {
        props: ['lista_id', 'user_id'],
        name: "DetalleUsuario",
        components: {
            MainContent, PageTitle, DatosUsuario
        }
    }
</script>